import { render } from "./ValidRelocateModal.vue?vue&type=template&id=2a2e04d2&ts=true&lang=pug"
import script from "./ValidRelocateModal.vue?vue&type=script&lang=ts"
export * from "./ValidRelocateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__